<section class="carousel container" *ngIf="eixos" id="eixo-tecnologico">
  <h1 class="title text-center">Cursos por Eixo Tecnológico</h1>
  <button class="arrow left btn" (click)="owlCar.prev()" role="button" aria-label="anterior">
    anterior
  </button>
  <owl-carousel-o [options]="customOptions" #owlCar aria-label="eixosTecnologicos">
    <ng-template carouselSlide *ngFor="let eixo of eixos">
      <a [routerLink]="['/eixo-tecnologico']" [queryParams]="{ id: eixo.id }" class="link">
        <div class="carousel-card bg-color-light-grey">
          <img src="/assets/comprimidas/{{ eixo.id }}/{{ eixo.linkThumb }}" alt="{{ eixo.nome }}" class="card-image" />
          <h1 class="card-title">{{ eixo.nome | removeEixo }}</h1>
        </div>
      </a>
    </ng-template>
  </owl-carousel-o>
  <button class="arrow right btn" (click)="owlCar.next()" role="button" aria-label="proximo">
    próximo
  </button>
</section>

<section class="carousel container" *ngIf="eixos" id="eixo-tecnologico">
  <div layout="row" layout-align="center center">
    <!-- <div align="center">
      <p _ngcontent-dfp-c12="" class="text-center text-uppercase negrito">Assista ao Vídeo de Divulgação da Campanha Nacional do Novo Catálogo</p> <br>
      <div class="iframe-container">
        <iframe lass="iframe-container" width="500" height="300" src="https://www.youtube.com/embed/hIUlWdNWl9o?start=1" title="YouTube video player" frameborder="3" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </div> -->
  </div>
</section>